"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));

var _ActionButton = _interopRequireDefault(require("../ActionButton/ActionButton"));

var Button = function Button(_ref) {
  var className = _ref.className,
      title = _ref.title,
      handleClick = _ref.handleClick,
      id = _ref.id;
  var parsedTitle = (0, _reactHtmlParser.default)(title)[0];

  if (typeof parsedTitle !== "string") {
    // eslint-disable-next-line prefer-destructuring
    parsedTitle = parsedTitle.props.children[0];
  }

  return /*#__PURE__*/_react.default.createElement(_ActionButton.default, {
    title: parsedTitle,
    type: "outline",
    className: className,
    handleClick: handleClick,
    id: id
  });
};

Button.propTypes = {
  className: _propTypes.default.string,
  title: _propTypes.default.any.isRequired,
  handleClick: _propTypes.default.func,
  id: _propTypes.default.string
};

var _default = (0, _styledComponents.default)(Button).withConfig({
  displayName: "Button",
  componentId: "sc-5y9v8i-0"
})(["width:inherit;min-width:150px;margin-right:17px;> span > a{color:inherit;font-size:inherit;font-weight:inherit;text-decoration:none;border-bottom:0px;}"]);

exports.default = _default;